<div class="container mb-5">
    <div class="row my-4">
        <div class="col-lg-1">
            <button id="account-back-btn" type="button" class="button ghost__button icon__left p-0 mt-4"
                (click)="goBack()">
                <em class="fa fa-arrow-left"></em>
                Back
            </button>
        </div>
        <div class="col-md-11">
            <div class="page-title d-flex" *ngIf="mainReportVersion">
                <div class="ellipsis w-auto">
                    {{mainReportVersion.COMPANY.NAME}}
                </div>
                <div class="reports-count small__text ml-3">{{reportVersionList.length + 1}} Reports</div>
            </div>
        </div>

        <div class="col-md-12">
            <div class="blue-box icon">
                <svg-icon name="info-icon" svgClass="mr-2"></svg-icon>
                <span class="color--black">Create different versions of the same report to view fluctuations and changes in the Company’s value.</span>
            </div>
        </div>

        <div class="col-md-12">
            <!-- Active Versions -->
            <div class="dashboard-report-grid--wrapper" *ngIf="mainReportVersion">
                <div class="py-2 font-size-32 font-weight-bold">Active Version</div>

                <div class="row card-view border-top border-bottom">
                    <div class="col-lg-4 col-md-12 col-12">
                        <div class="row mb-3 align-items-end">
                            <h4 class="col-md-8 font-weight-bold ellipsis" role="button" [popover]="mainReportVersion.VERSION_NAME?.length > 20 ? mainReportVersion.VERSION_NAME : ''"
                                triggers="mouseenter:mouseleave" placement="bottom left">
                                <ng-container *ngIf="mainReportVersion.VERSION_NAME">
                                    <span class="dashboard-report-gird--title">
                                        <span>{{mainReportVersion.VERSION_NAME}}</span>
                                    </span>
                                </ng-container>
                                <ng-container *ngIf="!mainReportVersion.VERSION_NAME">
                                    <span class="dashboard-report-gird--title" *ngIf="mainReportVersion.CREATED_DATE">
                                        <span>{{mainReportVersion.CREATED_DATE_FORMATTED_DATE}}</span>
                                        <span class="font-size-14 ml-1">{{mainReportVersion.CREATED_DATE_FORMATTED_TIME}}</span>
                                    </span>
                                    <span class="dashboard-report-gird--title"
                                        *ngIf="!mainReportVersion.CREATED_DATE">N/A</span>
                                </ng-container>
                            </h4>

                            <div class="col-md-4 detail">
                                <div class="label mb-0">Final Value</div>
                                <div class="value c-text--dark" *ngIf="mainReportVersion.VALUE">
                                    ${{mainReportVersion.VALUE | number}}</div>
                                <div class="value c-text--dark" *ngIf="!mainReportVersion.VALUE">$0</div>
                            </div>
                        </div>
                        <div class="">
                            <div class="dashboard-progress-container mb-0"
                                [ngClass]="mainReportVersion.COMPLETION == 100 ? 'completed' : 'active'">
                                <div class="progress w-100 dashboard-progress">
                                    <div class="progress-bar" role="progressbar"
                                        [style.width]="mainReportVersion.COMPLETION + '%'" aria-valuemin="0"
                                        aria-valuemax="100">
                                    </div>
                                </div>
                                <div class="percentage"
                                    [style.left]="mainReportVersion.COMPLETION > 90 ? (mainReportVersion.COMPLETION - 8)+ '%' : (mainReportVersion.COMPLETION)+ '%'">
                                    {{mainReportVersion.COMPLETION || 0}}%
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-6 col-md-8 col-8 detail">
                        <div class="row mb-3">
                            <div class="col-lg-4 col-md-6">
                                <div class="label">Company DBA</div>
                                <div class="value" *ngIf="mainReportVersion.COMPANY.DBA"
                                    [popover]="mainReportVersion?.COMPANY?.DBA?.length > 25 ? mainReportVersion.COMPANY.DBA : ''" triggers="mouseenter:mouseleave"
                                    placement="bottom left">{{mainReportVersion.COMPANY.DBA}}</div>
                                <div class="no-value" *ngIf="!mainReportVersion.COMPANY.DBA">No DBA</div>
                            </div>
                            <div class="col-lg-4 col-md-6">
                                <div class="label">Created Date</div>
                                <div class="value" *ngIf="mainReportVersion.CREATED_DATE">
                                    <span>{{mainReportVersion.CREATED_DATE_FORMATTED_DATE}}</span>
                                    <span class="font-size-14 ml-1">{{mainReportVersion.CREATED_DATE_FORMATTED_TIME}}</span>
                                </div>
                                <div class="no-value" *ngIf="!mainReportVersion.CREATED_DATE">N/A</div>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-2 col-md-4 col-4">
                        <div class="d-flex justify-content-end align-items-center">
                            <div class="mr-2">
                                <button type="button" id="notes-badge-button-active"
                                    class="btn rounded bg-white position-relative"
                                    (click)="openShowNoteModal(mainReportVersion)"
                                    [disabled]="!mainReportVersion.NOTES_LIST.length">
                                    <em class="fa fa-file-o color--blue"></em>
                                    <sup class="badge-number"><span>{{mainReportVersion.NOTES_LIST.length}}</span></sup>
                                </button>
                            </div>

                            <app-report-option [isVersionPage]="true" [isCurrentVersion]="true" [reportId]="reportId"
                                [reportName]="mainReportVersion.COMPANY.NAME"
                                [reportVersionId]="mainReportVersion.ID" (reloadPage)="getAllVersionList()"
                                [reportState]="mainReportVersion.STATE"
                                [isReportDone]="mainReportVersion.COMPLETION == 100 ? true : false"></app-report-option>
                        </div>

                    </div>
                </div>

            </div>

            <!-- Other Versions -->
            <div class="dashboard-report-grid--wrapper" *ngIf="reportVersionList.length">
                <h4 class="py-2 font-size-32 font-weight-bold">Other Versions</h4>
                <div class="row card-view border-top border-bottom"
                    *ngFor="let rpt of reportVersionList; let i = index;">
                    <div class="col-lg-4 col-md-12 col-12">
                        <div class="row mb-3 align-items-end">
                            <h4 class="col-md-8 font-weight-bold ellipsis" role="button" [popover]="rpt.VERSION_NAME?.length > 20 ? rpt.VERSION_NAME : ''"
                                triggers="mouseenter:mouseleave" placement="bottom left">
                                <ng-container *ngIf="rpt.VERSION_NAME">
                                    <span class="dashboard-report-gird--title">
                                        <span>{{rpt.VERSION_NAME}}</span>
                                    </span>
                                </ng-container>
                                <ng-container *ngIf="!rpt.VERSION_NAME">
                                    <span class="dashboard-report-gird--title" *ngIf="rpt.CREATED_DATE">
                                        <span>{{rpt.CREATED_DATE_FORMATTED_DATE}}</span>
                                        <span class="font-size-14 ml-1">{{rpt.CREATED_DATE_FORMATTED_TIME}}</span>
                                    </span>
                                    <span class="dashboard-report-gird--title" *ngIf="!rpt.CREATED_DATE">N/A</span>
                                </ng-container>
                            </h4>

                            <div class="col-md-4 detail">
                                <div class="label mb-0">Final Value</div>
                                <div class="value c-text--dark" *ngIf="rpt.VALUE">${{rpt.VALUE | number}}</div>
                                <div class="value c-text--dark" *ngIf="!rpt.VALUE">$0</div>
                            </div>
                        </div>
                        <div class="">
                            <div class="dashboard-progress-container previous_version mb-0 active2">
                                <div class="progress w-100 dashboard-progress">
                                    <div class="progress-bar" role="progressbar" [style.width]="rpt.COMPLETION + '%'"
                                        aria-valuemin="0" aria-valuemax="100">
                                    </div>
                                </div>
                                <div class="percentage"
                                    [style.left]="rpt.COMPLETION > 90 ? (rpt.COMPLETION - 8)+ '%' : (rpt.COMPLETION)+ '%'">
                                    {{rpt.COMPLETION || 0}}%
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-6 col-md-8 col-8 detail">
                        <div class="row mb-3">
                            <div class="col-lg-4 col-md-6">
                                <div class="label">Company DBA</div>
                                <div class="value" *ngIf="rpt.COMPANY.DBA" [popover]="rpt.COMPANY?.DBA?.length > 25 ? rpt.COMPANY.DBA : ''"
                                    triggers="mouseenter:mouseleave" placement="bottom left">{{rpt.COMPANY.DBA}}</div>
                                <div class="no-value" *ngIf="!rpt.COMPANY.DBA">No DBA</div>
                            </div>
                            <div class="col-lg-4 col-md-6">
                                <div class="label">Created Date</div>
                                <div class="value" *ngIf="rpt.CREATED_DATE">
                                    <span>{{rpt.CREATED_DATE_FORMATTED_DATE}}</span>
                                    <span class="font-size-14 ml-1">{{rpt.CREATED_DATE_FORMATTED_TIME}}</span>
                                </div>
                                <div class="no-value" *ngIf="!rpt.CREATED_DATE">N/A</div>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-2 col-md-4 col-4">
                        <div class="d-flex justify-content-end align-items-center">
                            <div class="mr-2">
                                <button type="button" id="notes-badge-button-other"
                                    class="btn rounded bg-white position-relative" [disabled]="!rpt.NOTES_LIST.length"
                                    (click)="openShowNoteModal(rpt)">
                                    <em class="fa fa-file-o color--blue"></em>
                                    <sup class="badge-number"><span>{{rpt.NOTES_LIST.length}}</span></sup>
                                </button>
                            </div>

                            <app-report-option [isVersionPage]="true" [isCurrentVersion]="false" [reportId]="reportId"
                                [reportName]="rpt.COMPANY.NAME"
                                [reportVersionId]="rpt.ID" (reloadPage)="getAllVersionList()" [reportState]="rpt.STATE"
                                [isReportDone]="rpt.COMPLETION == 100 ? true : false"></app-report-option>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
